import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { combineLatest, Observable, Subject } from "rxjs";
import { StateService } from "../../../core/providers/state/state.service";
import { filter, take, takeUntil, tap } from "rxjs/operators";
import { NGXLogger } from "ngx-logger";
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";
import { SiteRoute } from "../../../common/interfaces";

@Component({
    selector: 'vsf-general-entry-component',
    template: `
      <ng-container *ngIf="pageType === 'general'">
        <vsf-general-page></vsf-general-page>
      </ng-container>
      <ng-container *ngIf="pageType === 'product' || pageType === 'product-specific'">
        <vsf-product-page></vsf-product-page>
      </ng-container>
      <ng-container *ngIf="pageType === 'collection' || pageType === 'collection-specific'">
        <vsf-collection-page></vsf-collection-page>
      </ng-container>
    `
})
export class GeneralEntryComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    siteRoutes$: Observable<SiteRoute[] | null>;
    currentUrl: string;
    pageRoute$: Observable<string | null>;
    pageType: string;
    pageName: string;

    constructor(private stateService: StateService,
      private logger: NGXLogger,
      private router: Router,
    ) {}

    ngOnInit() {
        this.currentUrl = this.router.url.split('?')[0];
        this.stateService.select(state => state.siteRoutes)
        .pipe(takeUntil(this.destroy$)).subscribe(siteRoutes => {
            const currentUrl = this.router.url.split('?')[0];
            this.logger.debug(`[currentUrl]${currentUrl}`);
            if (siteRoutes && siteRoutes.length > 0) {
              const currentRoute = siteRoutes.find((route:any) => route.slug === currentUrl);
              if (!currentRoute) {
                this.logger.debug(`No matching page type found for URL ${currentUrl}. Redirecting to /not-found`);
                // Redirect to the not-found page if no match is found.
                this.router.navigate(['/not-found']);
                return;
              }
              this.pageType = currentRoute.type;
              this.pageName = currentRoute.name;
              this.logger.debug(`Page type for URL ${currentUrl} is ${this.pageType}`);
            } else {
                this.logger.debug(`No matching page type found for URL ${currentUrl}. Redirecting to /not-found`);
                // Redirect to the not-found page if no match is found.
                this.router.navigate(['/not-found']);
            }
        });
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
}
